/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Available_SlotsInputs */

const de_available_slots = /** @type {(inputs: Available_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Plätze`)
};

/** @type {(inputs: Available_SlotsInputs) => LocalizedString} */
const en_available_slots = () => /** @type {LocalizedString} */ ('available_slots')

/**

* @param {Available_SlotsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const available_slots = /** @type {((inputs?: Available_SlotsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Available_SlotsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_available_slots(inputs)
	return en_available_slots(inputs)
});